export default "__VITE_ASSET__DNpnQDy0__"